module.exports = __webpack_public_path__ + "img/3.8a0c23a8.jpg";